import React, { useState, useEffect } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  styled,
  InputLabel,
  Input,
  FormControl,
  Autocomplete,
  TextField,
  IconButton,
  Box,
} from "@mui/material";
import { Toaster } from "react-hot-toast";
import { Global } from "@emotion/react";
import UpdateOutlinedIcon from "@mui/icons-material/Edit";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import AddIcon from "@mui/icons-material/Add";
import FilterListIcon from "@mui/icons-material/FilterList";
import SendIcon from "@mui/icons-material/Send";
import TruncateText from "./TruncateText";

const buttonIcons = {
  Edit: <UpdateOutlinedIcon />,
  Delete: <DeleteOutlinedIcon />,
  Message: <MessageOutlinedIcon />,
  Response: <SendIcon />,
};

function TableComponent({
  tableHeaders,
  data,
  buttons,
  setEditId,
  addButton,
  addAction,
  deleteRecord,
  setEdit,
}) {
  const pages = [4, 8, 12];
  const [rowPerPage, setRowPerPage] = useState(pages[0]);
  const [page, setPage] = useState(0);
  const [filterText, setFilterText] = useState("");
  const [filterColumn, setFilterColumn] = useState(tableHeaders[0]?.field);
  const [showFilterOptions, setShowFilterOptions] = useState(false);

  useEffect(() => {
    setFilterColumn(tableHeaders[0]?.field);
  }, [tableHeaders]);

  const Container1 = styled(InputLabel)`
    color: aliceblue;

    &.Mui-focused {
      color: var(--white) !important;
    }
  `;

  const scrollbarStyles = `
  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: var(--color-gray-100);
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: var(--color-silver);
  }
`;

  const handleChangePage = (e, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (e) => {
    setRowPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const handleFilterColumnChange = (event, value) => {
    if (value && value.field) {
      setFilterColumn(value.field);
    }
  };

  const filteredData = data.filter((row) =>
    String(row[filterColumn]).toLowerCase().includes(filterText.toLowerCase())
  );
  const onEdit = (data) => {
    console.log(data);
    setEditId(data);
    {
      setEdit && setEdit(true);
    }
    addAction();
  };
  const onBtnClick = (data) => {
    setEditId(data);
    addAction();
  };
  const onDelete = (id) => {
    {
      deleteRecord && deleteRecord(id);
    }
  };
  return (
    <>
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "10px",
          paddingTop: "0",
        }}
      >
        <Box style={{ width: "75%" }}>
          <IconButton onClick={() => setShowFilterOptions(!showFilterOptions)}>
            <FilterListIcon style={{ color: "var(--white)" }} />
            <Typography
              variant="h6"
              style={{ marginLeft: "0.5vw", color: "var(--white)" }}
            >
              Filter
            </Typography>
          </IconButton>
          {showFilterOptions && (
            <Box>
              <FormControl style={{ width: "35%", marginRight: "2vw" }}>
                <Autocomplete
                  options={tableHeaders}
                  getOptionLabel={(option) => option.headerTitle}
                  onChange={handleFilterColumnChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Filter By"
                      variant="standard"
                      placeholder="Header Title"
                      value={filterColumn}
                    />
                  )}
                />
              </FormControl>
              <FormControl style={{ width: "35%" }}>
                <Container1>Filter Text</Container1>
                <Input
                  onChange={(e) => setFilterText(e.target.value)}
                  placeholder="Enter Text"
                  required
                  autoComplete="off"
                  value={filterText}
                  style={{
                    color: "white",
                  }}
                />
              </FormControl>
            </Box>
          )}
        </Box>
        <Box>
          {addButton && (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              style={{
                marginTop: "0.5vw",
                background: "var(--color-maroon)",
              }}
              onClick={addAction}
            >
              Add
            </Button>
          )}
        </Box>
      </Box>

      <TableContainer style={{ maxHeight: "53vh", minHeight: "53vh" }}>
        <Table>
          <TableHead>
            <TableRow
              style={{
                background: "var(--dark-purple)",
              }}
            >
              {tableHeaders &&
                tableHeaders.map((data) => {
                  return (
                    <TableCell
                      key={data.field}
                      style={{
                        color: "var(--white)",
                        fontWeight: 600,
                        borderBottom: "0.1vw solid var(--color-white-50)",
                      }}
                    >
                      {data.headerTitle}
                    </TableCell>
                  );
                })}
              {buttons && (
                <TableCell
                  style={{
                    color: "var(--white)",
                    fontWeight: 600,
                    borderBottom: "0.1vw solid var(--color-white-50)",
                    textAlign: "center",
                  }}
                >
                  {"Action"}
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData &&
              filteredData
                .slice(page * rowPerPage, (page + 1) * rowPerPage)
                .map((d) => {
                  return (
                    <TableRow key={d.id}>
                      {tableHeaders &&
                        tableHeaders.map((column) => {
                          let val = String(d[column.field]);
                          return (
                            <TableCell
                              key={val}
                              style={{
                                color: "var(--white)",
                                borderBottom:
                                  "0.1vw solid var(--color-white-50)",
                              }}
                            >
                              <TruncateText text={val} maxLength={60} />
                            </TableCell>
                          );
                        })}
                      {buttons && (
                        <TableCell
                          style={{
                            borderBottom: "0.1vw solid var(--color-white-50)",
                            padding: "0.8vw 0vh 0.8vw 0vh",
                            textAlign: "center",
                          }}
                        >
                          {buttons.map((btn, index) =>
                            btn.btnName === "Response" &&
                            d.status === "responded" ? null : (
                              <Button
                                key={index}
                                {
                                  // ...(btn.path
                                  // ? {
                                  //     ...(btn.btnName === "Edit"
                                  //       ? { href: `${btn.path}/${d.id}` }
                                  //       : { href: `${btn.path}` }),
                                  //   }
                                  // : {

                                  ...(btn.btnName === "Delete"
                                    ? { onClick: () => onDelete(d.id) }
                                    : btn.btnName === "Edit"
                                    ? { onClick: () => onEdit(d) }
                                    : { onClick: () => onBtnClick(d) })

                                  // })
                                }
                                style={{
                                  background: btn.bg
                                    ? btn.bg
                                    : "var(--color-black)",
                                  marginLeft: "1vw",
                                  color: "var(--white)",
                                  fontWeight: 600,
                                  borderBottom:
                                    "0.1vw solid var(--color-white-50)",
                                }}
                              >
                                {buttonIcons[btn.btnName]}
                              </Button>
                            )
                          )}
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}
          </TableBody>
          <TablePagination
            style={{
              background: "var(--dark-purple)",
              color: "var(--white)",
              borderBottom: "none",
            }}
            rowsPerPageOptions={pages}
            count={filteredData.length}
            rowsPerPage={rowPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Table>
        <Global styles={scrollbarStyles} />
        <Toaster />
      </TableContainer>
    </>
  );
}

export default TableComponent;
